import { render, staticRenderFns } from "./RdiGraphs.vue?vue&type=template&id=04b36036&scoped=true"
import script from "./RdiGraphs.vue?vue&type=script&lang=js"
export * from "./RdiGraphs.vue?vue&type=script&lang=js"
import style0 from "./RdiGraphs.vue?vue&type=style&index=0&id=04b36036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b36036",
  null
  
)

export default component.exports